import { HomeOutlined } from '@ant-design/icons'
import { Breadcrumb } from 'antd'

import { PTOV3Provider } from 'context/pto-v3-context-provider'

import Content from './content'
import Overview from './overview'

import './style.scss'

/**
 * PTO v3 (ERC-3643) detail.
 */
const PTOV3Detail = () => {
  return (
    <PTOV3Provider>
      <div className="main-section p2p-detail">
        <Breadcrumb
          items={[
            {
              href: '/',
              title: <HomeOutlined />,
            },
            {
              title: <span>PTO ERC-3643 Detail</span>,
            },
          ]}
          style={{ marginBottom: '20px' }}
        />
        <Overview />
        <Content />
      </div>
    </PTOV3Provider>
  )
}

export default PTOV3Detail
